import http from "../common/axios";
import { SearchCityResult } from "../types";

export async function getCityByTerm(term: string): Promise<SearchCityResult[]> {
  const response = await http.get(`places/autocomplete/${term}`);

  return response.data.map((data: any) => {
    const result: SearchCityResult = {
      name: data["structured_formatting"]["main_text"],
      longName: data["description"],
      position: {
        latitude: data["geometry"]["location"]["lat"],
        longitude: data["geometry"]["location"]["lng"],
      },
    };

    return result;
  });
}
